import setSpm from './setSpm';
import Url from 'url-parse';
export default class Tracker {
  /**
   * @param {string} spmA 站点点位
   * @param {string} spmB 页面点位
   * 设置页面AB位，需要确保已经在meta里设置了“不自动发送PV信息”
   */
  static setPageSPM(spmA, spmB) {
    setSpm({
      spmA: spmA,
      spmB: spmB,
    });
  }
  /**
   * 快捷曝光方法，使用了约定的DOM配置
   */
  static startExposure() {
    Tracker.autoExposure('/aliyun.exposure.autoexp', 'div', 'data-spm', ['name']);
  }
  /**
   * 开启曝光（手动方式）
   * @param {string} logkey 黄金令箭 logkey
   * @param {string} tag 需要曝光的目标DOM元素
   * @param {string} filter 需要曝光的目标DOM元素过滤属性
   * @param {array} name 需要传递的额外参数
   */
  static autoExposure(logkey, tag, filter, name = []) {
    const q = window.goldlog_queue || (window.goldlog_queue = []);
    q.push({
      action: 'goldlog.setMetaInfo',
      arguments: [
        'aplus-auto-exp',
        JSON.stringify([
          {
            logkey: logkey,
            tag: tag,
            filter: filter,
            props: name,
          },
        ]),
      ],
    });
  }
  /**
   * @param {string} url 目标URL
   * @param {string} domSelector 目标DOM元素
   * @returns {object} SPM String
   */
  static addSpm(url, domSelector) {
    if (window.g_SPM) {
      const spmObject = window.g_SPM.getParam(document.querySelector(domSelector));
      const spm = `${spmObject.a}.${spmObject.b}.${spmObject.c}.${spmObject.d}.${spmObject.e}`;
      const tempUrl = new Url(url, true);
      tempUrl.set('query', {
        ...tempUrl.query,
        spm: spm,
      });
      return tempUrl.toString();
    } else {
      return url;
    }
  }
  /**
   * @param {string} logkey 黄金令箭名称
   * @param {string} gmkey 事件类型
   * @param {string} gokey 参数
   */
  static record(logkey, gmkey, gokey) {
    if (window.goldlog) {
      window.goldlog.record(logkey, gmkey, gokey, 'GET');
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/tracker/index.js